import React from "react"
import PropTypes from "prop-types"

/**
 * Paso 3 — Datos del Paciente
 * Nombre, edad, y tipo de cliente. El teléfono del paciente y la fecha de
 * nacimiento se dejaron de solicitar (ver campos ocultos más abajo) — la
 * edad ahora se captura directamente como texto libre en vez de calcularse
 * a partir de la fecha de nacimiento.
 */
const StepPaciente = ({
    // Nombre
    nombrePaciennteHadError,
    nombrePaciente,
    onChangeNombrePaciente,
    MAX,
    // Teléfono del paciente
    telefonoPacienteHadError,
    telefonoPaciente,
    onChangeTelefonoPaciente,
    // Edad
    edad,
    onChangeEdad,
    // Fecha de nacimiento
    fechaNacimientoHadError,
    fecha_nacimiento,
    today,
    onChangeNacimientoDate,
    isCheckedFechaNoSeCuenta,
    handleCheckboxChangeFechaNacimiento,
    // Tipo de cliente
    tipoClienteHadError,
    tipoCliente,
    onChangeTipoCliente,
    onFocusTipoCliente,
    onBlurTipoCliente,
    onChangeTypeCliente,
    // ¿Paciente hospitalizado?
    pacienteHospitalizado,
    onCheckPacienteHospitalizado,
}) => (
    <div className="rq-panel">

        {/* Nombre del paciente */}
        <div className={nombrePaciennteHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorNombrePaciente">
            <label className="rq-label">Nombre del paciente<span className="rq-required">*</span></label>
            <div className="rq-content">
                <input
                    type="text"
                    id="nombrePaciente"
                    name="nombrePaciente"
                    className="rq-input"
                    value={nombrePaciente}
                    onChange={onChangeNombrePaciente}
                    placeholder="Nombre completo"
                    maxLength={MAX.nombre}
                />
            </div>
        </div>

        {/* Teléfono del paciente — oculto por el momento a petición. No se
            elimina la lógica, solo se deja de mostrar/solicitar. Para
            reactivar, descomentar este bloque. */}
        {/*
        <div className={telefonoPacienteHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorTelefonoPaciente">
            <label className="rq-label">Número del paciente<span className="rq-required">*</span></label>
            <div className="rq-content">
                <input
                    type="text"
                    id="telefonoPaciente"
                    name="telefonoPaciente"
                    className="rq-input"
                    value={telefonoPaciente}
                    onChange={onChangeTelefonoPaciente}
                    placeholder="10 dígitos"
                    maxLength={MAX.telefono}
                />
            </div>
        </div>
        */}

        {/* Edad — reemplaza a Fecha de nacimiento (texto libre) */}
        <div className="rq-field" id="contenedorEdad">
            <label className="rq-label">Edad<span className="rq-required">*</span></label>
            <div className="rq-content">
                <input
                    type="text"
                    id="edad"
                    name="edad"
                    className="rq-input"
                    value={edad}
                    onChange={onChangeEdad}
                    placeholder="Ej. 45 años"
                    maxLength={MAX.edad}
                />
            </div>
        </div>

        {/* Fecha de nacimiento — oculta por el momento a petición, se
            reemplazó por el campo de Edad de arriba. No se elimina la
            lógica (sigue calculando fechaNacimientoHadError internamente,
            aunque ya no se valida al avanzar de paso). Para reactivar,
            descomentar este bloque. */}
        {/*
        <div className={fechaNacimientoHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorFechaNacimiento">
            <label className="rq-label">Fecha de nacimiento<span className="rq-required">*</span></label>
            <div className="rq-content">
                <input
                    type="date"
                    id="fecha_nacimiento"
                    name="fecha_nacimiento"
                    className="rq-input"
                    value={fecha_nacimiento}
                    max={today}
                    onChange={onChangeNacimientoDate}
                />
                <label className="rq-checkbox-item">
                    <input
                        type="checkbox"
                        checked={isCheckedFechaNoSeCuenta}
                        onChange={handleCheckboxChangeFechaNacimiento}
                    />
                    No se cuenta con la información
                </label>
            </div>
        </div>
        */}

        {/* ¿Paciente hospitalizado? */}
        <div className="rq-field" id="contenedorPacienteHospitalizado">
            <label className="rq-label">
                <input
                    type="checkbox"
                    checked={pacienteHospitalizado}
                    onChange={onCheckPacienteHospitalizado}
                    style={{ marginRight: "8px" }}
                />
                ¿Es paciente hospitalizado?
            </label>
        </div>

        {/* Tipo de cliente */}
        <div className={tipoClienteHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorTipoCliente">
            <label className="rq-label">Tipo de cliente<span className="rq-required">*</span></label>
            <p className="rq-hint">Indique el tipo de convenio del cliente</p>
            <div className="rq-content rq-radio-group" onChange={onChangeTypeCliente}>
                <label className="rq-radio-item"><input type="radio" value="Gobierno"    name="clienteType"/> Gobierno</label>
                <label className="rq-radio-item"><input type="radio" value="Privado"     name="clienteType"/> Privado</label>
                <label className="rq-radio-item"><input type="radio" value="Aseguradora" name="clienteType"/> Aseguradora</label>
                <label className="rq-radio-item"><input type="radio" value="Empresa"     name="clienteType"/> Empresa</label>
                <label className="rq-radio-item"><input type="radio" value="Oficina"     name="clienteType"/> Oficina</label>
            </div>
            <div className="rq-content">
                <input
                    type="text"
                    id="tipoCliente"
                    name="tipoCliente"
                    className="rq-input"
                    value={tipoCliente}
                    onChange={onChangeTipoCliente}
                    onFocus={onFocusTipoCliente}
                    onBlur={onBlurTipoCliente}
                    placeholder="Especifique el convenio o aseguradora"
                    maxLength={MAX.tipoCliente}
                />
            </div>
        </div>

    </div>
)

export default StepPaciente

StepPaciente.propTypes = {
    // Nombre
    nombrePaciennteHadError:              PropTypes.bool.isRequired,
    nombrePaciente:                       PropTypes.string.isRequired,
    onChangeNombrePaciente:               PropTypes.func.isRequired,
    MAX:                                  PropTypes.object.isRequired,
    // Teléfono del paciente
    telefonoPacienteHadError:             PropTypes.bool.isRequired,
    telefonoPaciente:                     PropTypes.string.isRequired,
    onChangeTelefonoPaciente:             PropTypes.func.isRequired,
    // Edad
    edad:                                 PropTypes.string.isRequired,
    onChangeEdad:                         PropTypes.func.isRequired,
    // Fecha de nacimiento
    fechaNacimientoHadError:              PropTypes.bool.isRequired,
    fecha_nacimiento:                     PropTypes.string.isRequired,
    today:                                PropTypes.string.isRequired,
    onChangeNacimientoDate:               PropTypes.func.isRequired,
    isCheckedFechaNoSeCuenta:             PropTypes.bool.isRequired,
    handleCheckboxChangeFechaNacimiento:  PropTypes.func.isRequired,
    // Tipo de cliente
    tipoClienteHadError:                  PropTypes.bool.isRequired,
    tipoCliente:                          PropTypes.string.isRequired,
    onChangeTipoCliente:                  PropTypes.func.isRequired,
    onFocusTipoCliente:                   PropTypes.func.isRequired,
    onBlurTipoCliente:                    PropTypes.func.isRequired,
    onChangeTypeCliente:                  PropTypes.func.isRequired,
    // ¿Paciente hospitalizado?
    pacienteHospitalizado:                PropTypes.bool.isRequired,
    onCheckPacienteHospitalizado:         PropTypes.func.isRequired,
}